import SearchVideoList from "../search/SearchVideoList";
import VideoCreate from "./Create";
import VideoEdit from "./Edit";
import VideoShow from "./Show";

export default {
  list: SearchVideoList,
  create: VideoCreate,
  edit: VideoEdit,
  show: VideoShow,
};
